import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const LightWindowBox = styled.article`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 95%;
  height: 95%;
  transform: translate(-50%, -50%);
  .slick-prev,
  .slick-next {
    width: auto;
    height: auto;
    cursor: pointer;
    z-index: 2;
    img {
      height: 30px;
    }
    &:before {
      display: none;
    }
  }
  .slick-next {
    right: 5px;
    @media (min-width: ${breakpoints.tablet}) {
      right: 40px;
    }
  }
  .slick-prev {
    left: 5px;
    @media (min-width: ${breakpoints.tablet}) {
      left: 40px;
    }
    img {
      transform: rotate(180deg);
      float: left;
    }
  }
  .slick-slider {
    height: 100%;
    display: flex !important;
  }
  .slick-list,
  .slick-track {
      height: 100% !important;
  }
  .inside {
    background: white;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    overflow: auto;
    @media (min-width: ${breakpoints.tablet}) {
      overflow: hidden;
    }
  }
  h2, main {
    display: inline-block;
    flex: 1 1 auto;
    width: 100%;
    padding: 0;
    justify-content: center;
    @media (min-width: ${breakpoints.tablet}) {
      display: flex;
    }
  }
  h2 {
    display: flex;
    align-items: flex-end;
    width: 90%;
    padding: 10% 0 0 0;
    @media (min-width: ${breakpoints.tablet}) {
      width: 100%;
      padding: 0;
    }
  }
  main {
    @media (min-width: ${breakpoints.tablet}) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 80%;
      max-width: 620px;
      margin: 30px auto;
      @media (min-width: ${breakpoints.tablet}) {
        width: 40%;
        margin: 0;
      }
    }
    p {
      width: 80%;
      padding: 0 10%;
      @media (min-width: ${breakpoints.tablet}) {
        width: 35%;
        padding: 0 5% 0 0;
      }
    }
  }
`;

export default LightWindowBox;



// WEBPACK FOOTER //
// ./src/styled-components/LightWindowBox.js